import { render, staticRenderFns } from "./tokens.vue?vue&type=template&id=195e7b67&"
import script from "./tokens.vue?vue&type=script&lang=js&"
export * from "./tokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports